module.exports = __webpack_public_path__ + "img/loading-agenda.c3a574a8.svg";